import React, { ChangeEvent, FC, useState } from 'react';
import { ColorResult, SketchPicker } from 'react-color';
import styled from '@emotion/styled';

const Swatch = styled.div`
    background: #fff;
    border-radius: 1px;
    box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    display: inline-block;
    padding: 5px;
`;

const Popover = styled.div`
    position: absolute;
    z-index: 2;
`;

const Color = styled.div<{ color: string }>`
    background: ${({ color }) => color};
    border-radius: 2px;
    height: 14px;
    width: 36px;
`;

const Cover = styled.div`
    bottom: 0px;
    left: 0px;
    position: fixed;
    right: 0px;
    top: 0px;
`;

interface Props {
    color: string;
    onChange: (color: ColorResult, event: ChangeEvent<HTMLInputElement>) => void;
}

const ColorPicker: FC<Props> = ({ color, onChange }) => {
    const [open, setOpen] = useState(false);

    return (
        <div>
            <Swatch onClick={() => setOpen(!open)}>
                <Color color={color} />
            </Swatch>
            {open ? (
                <Popover>
                    <Cover onClick={() => setOpen(false)} />
                    <SketchPicker disableAlpha color={color} onChange={onChange} />
                </Popover>
            ) : null}
        </div>
    );
};

export default ColorPicker;
